<template>
    <div>
        <slot v-bind:data="appData"></slot>
    </div>
</template>
<script>
    export default {
        // created() {
        //     this.fullscreen = this.$loading({
        //         lock: true,
        //         text: 'Loading'
        //     });
        //     $(document).ready(() => {
        //         this.fullscreenLoading.close();
        //     });
        // },
        mounted() {
            if (this.appData.hasError) {
                window.kinfEvents.$emit('ErrorsPage', {error: this.appData.errors, old: this.appData.old});
            }
            window.kinfEvents.$emit('LoginButton:sendFormData', this.appData.globalData.routes.login, this.appData.csrf_token);
            window.kinfEvents.$emit('DonatorsComments:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('FundraiserDetails:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('FundraiserUpdates:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('FundraiserFilter:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('PageThankYou:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('FundingDonators:sendRoutes', this.appData.globalData.routes);
            window.kinfEvents.$emit('EditProfile:sendRoutes', this.appData.globalData.routes);

        },
        props:{
            auth:{
                required:true,
                type:Boolean,
            },
            user:{
                required:false,
            }
        },
        data() {
            return {
                appData: null,
                fullScreenLoading: null,
            }
        },
        created() {
            this.appData = window.App;
        },

    }
</script>
<style>
    .el-loading-spinner .path {
        stroke: red !important;
    }

    .el-loading-spinner .el-loading-text {
        color: red !important;
    }
</style>




// WEBPACK FOOTER //
// resources/js/components/KinfApp.vue